import React from 'react';
import { Box, TextField } from 'vindi-ds-components';

const Field = ({
  title, handleChange, disabled, value, type,
}) => (
  <Box css={{ marginBottom: '0.5em', width: '100%' }}>
    <TextField
      label={title}
      id={title}
      size='medium'
      placeholder={title}
      onChange={(e) => handleChange(e.target.value)}
      disabled={disabled}
      value={value}
      type={type}
    />
  </Box>
);

export default Field;
